module.exports = __webpack_public_path__ + "static/media/header.eee56ee7.png";